import { NumberOfCallersReportParameter } from '@ndt/report-output/shared/models/number-of-callers-report-parameter';
import { ReportParameters } from 'generated/graphql-types';
import { ParameterFormValueBase } from '../report-parameter-list/models/report-parameter-form-value';

export interface NumberOfCallersReportParameterValue {
   value: NumberOfCallersReportParameter | any;
}

export interface NumberOfCallersParameterFormModel extends ParameterFormValueBase {
   parameterType: ReportParameters.NumberOfCallers;
}

export const defaultNumberOfCallersParameter: NumberOfCallersReportParameterValue = {
   value: 50,
};
